import { fetchServer } from "@/features/utils/fetch";
import type {
  CheckEmailProps,
  CheckEmailResponse,
  ConfirmationResponse,
  ConfirmationResponseData,
  ErrorResponse,
  RegisterCredentialType,
  VerifyEmailCredentials
} from "../types";
import { UserType } from "@/features/user/types";

export class RegisterApiClient {
  static async checkEmail(credentials: CheckEmailProps) {
    const response = await fetchServer(`/register/check_email`, {
      method: "POST",
      reloadOn401: false,
      body: {
        email: credentials.email,
        recaptcha: credentials.captcha_token,
        language: credentials.language
      }
    });
    const res = await response.json();
    try {
      const parsedJSON = JSON.parse(res.message);
      return parsedJSON as CheckEmailResponse;
    } catch (_) {
      return res as ErrorResponse<CheckEmailResponse>;
    }
  }

  static async validateEmail(
    encryptedData: string,
    code: string,
    credentials: VerifyEmailCredentials,
    askProfile?: boolean
  ): Promise<ConfirmationResponseData<UserType> & { token?: string | null }> {
    const response = await fetchServer(`/register/validate_email`, {
      method: "POST",
      reloadOn401: false,
      body: {
        encryptedData,
        code,
        askProfile,
        credentials: JSON.stringify(credentials)
      }
    });

    if (!response.ok) {
      return { success: false, message: "", token: null };
    } else {
      const res = await response.json();
      return { success: true, message: res.message, token: res.token, data: res.profile };
    }
  }

  static async completeCredential(
    credentials: RegisterCredentialType
  ): Promise<ConfirmationResponse> {
    const response = await fetchServer(`/register/complete_credential`, {
      method: "POST",
      reloadOn401: false,
      body: {
        // @TODO: Double stringify (one in fetch server, second here) is necessary besause the backend json_decode's two times, ask Xavier to correct that
        credentials: JSON.stringify(credentials),
        jwt_otp: credentials.jwt_otp
      }
    });
    return response.status === 200 ? { success: true, message: "" } : await response.json();
  }
}
